import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Projects from './Projects';
import Skills from './Skills';
import Contact from './Contact';
import SEO from '../SEO';

const MainContent = () => {
  useEffect(() => {
    // Ensure we start at the top so animations trigger correctly
    window.scrollTo(0, 0);
    
    // Optional safety: If GSAP fails, manually reveal content after a delay
    const t = setTimeout(() => {
        const hiddenElements = document.querySelectorAll('.fade-in');
        hiddenElements.forEach(el => el.classList.add('visible'));
    }, 500);
    
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <SEO
        title="Namal Chamodya | Developer Portfolio — Web, Electronics, IoT & 3D Design"
        description="Explore Namal Chamodya's portfolio showcasing full-stack web development, electronic engineering, IoT & embedded systems projects, PCB designs, 3D modeling, UI/UX design, and creative art. Sri Lanka's multi-disciplinary tech professional."
        keywords="Namal Chamodya portfolio, web developer Sri Lanka, electronic engineer portfolio, IoT engineer, embedded systems engineer, PCB designer, 3D designer, digital artist, creative art, full stack developer, React developer, Arduino projects, UI/UX designer, graphic designer, writer, editor"
        canonical="/portfolio"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ProfilePage",
          "name": "Namal Chamodya — Developer Portfolio",
          "description": "Full-stack developer, electronic engineer, IoT specialist, PCB designer, 3D artist & creative designer portfolio.",
          "url": "https://namal-chamodya.space/portfolio",
          "mainEntity": {
            "@type": "Person",
            "name": "Namal Chamodya",
            "jobTitle": "Creative Developer, Electronic Engineer & ICT Educator"
          }
        }}
      />
      <Navbar />
      {/* Added min-height to ensure the container takes up space 
         even if animations are slow to load 
      */}
      <div className="container" style={{ position: 'relative', zIndex: 1, minHeight: '100vh' }}>
        <Home />
        <About />
        <Projects />
        <Skills />
        <Contact />
      </div>
    </>
  );
};

export default MainContent;


